<template>
  <nav>
    <v-app-bar flat dense app>
      <v-app-bar-nav-icon
        class="grey--text"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <router-link to="/" style="text-decoration: none"
        ><v-toolbar-title class="text-uppercase mr-10">
          <span class="schuberthMain--text font-weight-light">SCHUBERTH</span>
          <span class="schuberthMain--text">INTERN</span>
        </v-toolbar-title>
      </router-link>

      <v-spacer></v-spacer>

      <v-btn text class="grey--text" @click="logout">
        <v-icon>mdi-logout</v-icon>LOGOUT
      </v-btn>
      <v-btn text class="grey--text" :href="this.$config.loginUrl"
        ><v-icon class="mr-1">mdi-home-circle-outline</v-icon> Home</v-btn
      >
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      class="schuberthCarbon"
      :src="'./nav/' + randomPic"
    >
      <v-layout column align-center>
        <v-flex class="mt-5">
          <a href="https://intern.schuberth.info">
            <v-avatar size="100">
              <img :src="'./lazy_head_.png'" />
            </v-avatar>
          </a>
        </v-flex>
        <v-flex>
          <p class="white--text subheading mt-1">
            {{ userName }}
          </p>
          <div class="mt-n1 text-center" v-show="showPhone">
            <v-badge color="orange darken-4" content="Beta" overlap>
              <v-btn-toggle rounded dark v-model="phoneToggle">
                <v-btn
                  :color="currentStatus == 'office' ? 'green' : null"
                  small
                  @click="setStatus('office')"
                  ><v-icon>mdi-office-building</v-icon></v-btn
                >
                <v-btn
                  :color="currentStatus == 'homeoffice' ? 'green' : null"
                  small
                  @click="setStatus('homeoffice')"
                  ><v-icon>mdi-home-account</v-icon></v-btn
                >
              </v-btn-toggle>
            </v-badge>
          </div>
        </v-flex>
      </v-layout>
      <v-list dark>
        <v-list-item
          v-for="link in links"
          :key="link.text"
          :href="link.route"
          class="my-1 text-right list-item"
          :disabled="checkPermission(link.scope)"
          target="_blank"
          rel="noopener noreferrer"
        >
          <v-list-item-action>
            <v-icon color="white">{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              link.text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Navbar",
  data: () => ({
    drawer: false,
    showPhone: true,
    currentStatus: "",
    phoneToggle: -1,
    lastUpdateTKStatus: null,
  }),
  computed: {
    randomPic: function () {
      return Math.floor(Math.random() * 13 + 1) + ".jpg";
    },
    ...mapGetters(["userName", "links", "decodedJwt"]),
  },
  methods: {
    logout: function () {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
      return;
    },
    checkPermission: function (scope) {
      return scope.length == 0
        ? false
        : this.decodedJwt !== null
        ? !this.decodedJwt.user.scopes.some((item) => scope.includes(item))
        : true;
    },
    setStatus: async function (status) {
      await this.$store.dispatch("setTKStatus", status);
      await this.getStatus();
    },
    getStatus: async function () {
      const status = await this.$store.dispatch("getTKStatus");
      switch (status) {
        case "office":
          this.showPhone = true;
          this.phoneToggle = 0;
          this.currentStatus = "office";
          break;
        case "homeoffice":
          this.showPhone = true;
          this.phoneToggle = 1;
          this.currentStatus = "homeoffice";
          break;
        default:
          this.showPhone = false;
          this.phoneToggle = -1;
          this.currentStatus = "";
          break;
      }
    },
  },
  created: async function () {
    await this.$store.dispatch("getNavbar");
    //await this.getStatus();
  },
  beforeUpdate: async function () {
    //await this.$store.dispatch("getNavbar");

    if (new Date(this.lastUpdateTKStatus).setSeconds(new Date(this.lastUpdateTKStatus).getSeconds() + 30) < new Date()) {
      await this.getStatus();
      this.lastUpdateTKStatus = new Date();
    }
  },
};
</script>

<style>
.list-item {
  background-color: rgba(34, 34, 34, 0.8);
}
.v-list-item--disabled {
  background-color: rgba(193, 51, 51, 0.23);
}
</style>
